import richtextTooltip from './richtextTooltip'

const richtextApi = {
  el: {
    sections: document.querySelectorAll('.canContainApiWords'),
  },

  init() {
    if (this.el.sections) {
      this.el.sections.forEach((section) => {
        const text = section.innerHTML
        const matches = text.match(/\[(.*?)]/g)
        const words = [] as Array<string>
        if (matches !== null) {
          matches.map((val) => {
            let word = val.replace('[', '')
            word = word.replace(']', '')
            words.push(word)
          })
        }
        if (words.length > 0) {
          this.getApiValues(words, section)
        }
      })
    }
  },

  getApiValues: async (words, section) => {
    const action = '/umbraco/api/data/GetCurrentData'
    const method = 'GET'

    fetch(action, {
      method: method,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          // console.log('success', response)
          richtextApi.renderApiValues(words, section, response)
          richtextTooltip.getTooltips(section)
        } else {
          console.log('error', response)
        }
      })
      .catch((ex) => {
        console.log('Server error: ', ex)
      })
  },

  renderApiValues: (words, section, response) => {
    const res = JSON.parse(response.data)
    const keys = Object.keys(res)
    let text = section.innerHTML

    words.forEach((word) => {
      const selectedWord = `[${word}]`

      if (keys.includes(word)) {
        text = text.replace(selectedWord, res[word])
      } else {
        text = text.replace(selectedWord, word)
      }
    })

    section.innerHTML = text
  },
}

export default richtextApi
